// extracted by mini-css-extract-plugin
module.exports = {"results":"SearchResults_results__Id3k6","result":"SearchResults_result__36oQa"};